// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__EUd4U","card":"styles_card__wCDxC","name":"styles_name__iZFSs","my40":"styles_my40__9fz5a","text16":"styles_text16__I46xJ"};